document.addEventListener('DOMContentLoaded', () => {
	document.addEventListener('facetwp-loaded', () => {
		const searchField = document.querySelector('#search-field');

		if (searchField) {
			const searchTerm = searchField.querySelector('input').value;

			if (searchTerm !== null && searchTerm !== undefined && searchTerm !== '') {
				// document.querySelector('.search #search-query').textContent = searchTerm;
				document
					.querySelectorAll('.search-container .toggle, .search-results, .loadmore, .total-results')
					.forEach((element) => {
						element.classList.remove('hidden');
					});
			} else {
				// document.querySelector('.search #search-query').textContent = '';
				document
					.querySelectorAll('.search-container .toggle, .search-results, .loadmore, .total-results')
					.forEach((element) => {
						element.classList.add('hidden');
					});
			}
		}
	});
});
